import { imageComponent } from './image'
import { colorComponent } from './color'
import { videoComponent } from './video'
// import { polopolyComponent } from './polopoly'
// import { uncroppedComponent } from './uncropped'
import { panoramaComponent } from './panorama'
import { flipScrollComponent } from './flipScroll'
import { triggerOnScrollComponent } from './triggerOnScroll'
import { animateVideoComponent } from './animateVideo'
import { setActiveElementClass } from './renderless/activeClass'

export const components = [
  setActiveElementClass,
  imageComponent,
  colorComponent,
  videoComponent,
  // polopolyComponent,
  // uncroppedComponent,
  panoramaComponent,
  triggerOnScrollComponent,
  flipScrollComponent,
  animateVideoComponent
]



// WEBPACK FOOTER //
// ./src/shared/components/index.js